/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames/bind';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { ToastContainer, toast } from 'react-toastify';

import { useMutation } from '@apollo/client';
import * as Q from '../../../../../constants/graphqlQueries';

import colors from '../../../../../constants/colors';

import './CreateCodeMapping.css';
import SwitchCustom from '../../../../Switch/SwitchCustom';
import ScheduleCodeMapping from './ScheduleCodeMapping/ScheduleCodeMapping';
import ACDCodeMapping from './ACDCodeMapping/ACDCodeMapping';

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D5D5',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D5D5',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D5D5',
          },
        },
      },
    },
  },
});
const useStyles = makeStyles(() => ({
  inputText: {
    width: '100%',
  },
  rowFooter: {
    display: 'flex',
    justifyContent: 'space-evenly',
    padding: '0 20px',
  },
  button: {
    marginTop: '0.5rem',
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    width: '125px',
    color: '#000 !important',
    '&:hover': {
      backgroundColor: '#F1F0EF',
    },
    letterSpacing: '0',
    textTransform: 'none !important',
  },
  container: {
    display: 'flex',
    marginTop: '5px',
  },
  dashboard: {
    marginTop: '5px',
  },
  boxLayout: {
    boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18)',
    borderRadius: '2px',
    background: '#ffffff',
    fontSize: '1.4rem',
  },
  boxLayoutHeader: {
    boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18)',
    borderRadius: '2px',
    background: '#ffffff',
    marginTop: '5px',
    padding: '0.5rem 0 1rem 1rem'
  },
  boxLayoutTitle: {
    fontWeight: '700',
    lineHeight: '20px',
    color: colors.blue,
    marginBottom: '12px',
    fontSize: '1.8rem',
  },
  boxLayoutSubtitle: {
    fontSize: '1.4rem',
  },
  boxDivLayout: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    margin: '0 3rem 0 0'
  },
  boxDivLayoutTwo: {
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    display: 'block',
    margin: '1rem 0',
  },
  fieldTitle: {
    fontWeight: '400',
    fontSize: '1.4rem',
    marginBottom: '14px',
  },
  footerButtonContainer: {
    marginBottom: '16px',
  },
  tooltip: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ListItemButton: {
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  boxContainerLayout: {
    display: 'flex',
    marginLeft: '1rem'
  }
}));

const SEARCH_TAB = { index: 0, label: 'Search', default: true };
const CODE_MAPPING_TYPES = { ACD: 'ACD', schedule: 'Schedule'};
const switchOptions = {
  leftTitle: CODE_MAPPING_TYPES.ACD,
  rightTitle: CODE_MAPPING_TYPES.schedule,
};

const CreateCodeMapping = ({ codeMappingId, codeMappingTypeToEdit, handleClearEdit, handleSelected }) => {
  const classes = useStyles();
  const cx = classNames.bind(classes);

  const [codeMappingType, setCodeMappingType] = useState(false);
  const [ACDCodeMappingId, setACDCodeMappingId] = useState();
  
  const [codeLabelFail, setCodeLabelFail] = useState(false);

  const [updateOrCreateCodeMapping, { data: createCodeMapping }] = useMutation(Q.CODE_MAPPING_CREATE_UPDATE_MUTATION,
    {
      onError: error => {
        setCodeLabelFail(true);
        return toast(error.message)
      }
    }
  );
  const [updateOrCreateACDCodeMapping, { data: createACDCodeMapping }] = useMutation(Q.ACD_CODE_MAPPING_CREATE_UPDATE,
    {
      onError: error => {
        setCodeLabelFail(true);
        return toast(error.message)
      }
    }
    );

  const handleCancel = (_, response=null) => {
    handleClearEdit();
    handleSelected(SEARCH_TAB, response);
  };
  const handleCodeTypes = checked => setCodeMappingType(checked);

  useEffect(() => {
    if (createCodeMapping) handleCancel(null, createCodeMapping.updateOrCreateCodeMapping.status);
  }, [createCodeMapping]);
  useEffect(() => {
    if (createACDCodeMapping) handleCancel(null, createACDCodeMapping.updateOrCreateACDCodeMapping.status);
  }, [createACDCodeMapping]);

  const submitScheduleMapping = input => updateOrCreateCodeMapping({ variables: { input } });
  const submitACDMapping = input => updateOrCreateACDCodeMapping({ variables: { input } });

  useEffect(() => {
    if (codeMappingTypeToEdit === CODE_MAPPING_TYPES.schedule) setCodeMappingType(true)
    else setACDCodeMappingId(codeMappingId)
}, [codeMappingTypeToEdit]);
  useEffect(() => {
    if (codeLabelFail) setCodeLabelFail(!codeLabelFail)
}, [codeLabelFail]);

  return (
    <ThemeProvider theme={theme}>
      <Grid container direction='column' className={classes.container}>
        <Grid item className={classes.boxLayoutHeader}>
          <p className={classes.boxLayoutTitle}>Code Mapping Type</p>
          <SwitchCustom
            options={switchOptions}
            handleSwitch={handleCodeTypes}
            switchStatus={codeMappingType}
            isDualOption
          />
        </Grid>
        <Grid container direction='column' className={cx(classes.boxLayout, classes.dashboard)}>
          {!codeMappingType ? 
            <ACDCodeMapping 
              ACDCodeMappingId={ACDCodeMappingId} 
              handleClearEdit={handleClearEdit} 
              handleSubmit={submitACDMapping}
              error={codeLabelFail}
            />
            : <ScheduleCodeMapping 
                codeMappingId={codeMappingId} 
                handleClearEdit={handleClearEdit} 
                handleSubmit={submitScheduleMapping}
                error={codeLabelFail}
            />}
        </Grid>
      </Grid>
      <ToastContainer hideProgressBar/>
    </ThemeProvider>
  );
};

CreateCodeMapping.propTypes = {
  codeMappingId: PropTypes.number,
  codeMappingTypeToEdit: PropTypes.string,
  handleClearEdit: PropTypes.func.isRequired,
  handleSelected: PropTypes.func.isRequired
};

CreateCodeMapping.defaultProps = {
  codeMappingId: undefined,
  codeMappingTypeToEdit: undefined
};

export default CreateCodeMapping;
